























import { defineComponent, onMounted, onUnmounted, ref, toRefs, watchEffect } from "@vue/composition-api";
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import { isImageFile } from "@/lib/fileHelpers";
import { DragMode, ViewMode } from "@/components/ImageCropper/types";

export default defineComponent({
  name: "ImageEditor",
  props: {
    file: { type: File, required: true },
    showEditor: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const { file, showEditor } = toRefs(props);
    const image = ref();
    const zoomRatio = ref(0);
    const imageSrc = ref("");
    let cropper: Cropper;
    const viewMode: ViewMode = 1;
    const dragMode: DragMode = "none";
    const cropperOptions = {
      aspectRatio: 1,
      viewMode: viewMode,
      dragMode: dragMode,
      cropBoxMovable: false,
      cropBoxResizable: false,
      background: false,
      guides: false,
      center: false,
      modal: false,
      responsive: true,
      zoomable: true,
      zoomOnWheel: false,
      zoomOnTouch: false,
      toggleDragModeOnDblclick: false,
      ready: () => {
        cropper.clear();
        const isLandscapeImage = cropper.getImageData().naturalWidth > cropper.getImageData().naturalHeight;
        if (!isLandscapeImage) {
          zoomRatio.value = 1 - cropper.getCanvasData().height / cropper.getContainerData().width;
        } else {
          zoomRatio.value = -(1 - cropper.getCanvasData().width / cropper.getContainerData().height);
        }
      },
    };

    const handleRotate = () => {
      cropper.rotate(90);
      const isLandscapeCanvas = cropper.getCanvasData().width > cropper.getCanvasData().height;
      cropper.zoom(isLandscapeCanvas ? zoomRatio.value : -zoomRatio.value);
    };

    const handleFlipHorizontal = () => {
      cropper.scaleX(-cropper.getData().scaleX || -1);
    };

    const handleFlipVertical = () => {
      cropper.scaleY(-cropper.getData().scaleY || -1);
    };

    const saveEditedImage = () => {
      cropper.getCroppedCanvas().toBlob(blob => {
        emit("imageEdited", blob);
      }, "image/jpeg");
    };

    const getImageSrc = (imageFile: File) => {
      if (!isImageFile(imageFile)) return;
      const fileReader = new FileReader();
      fileReader.readAsDataURL(imageFile);
      fileReader.onload = event => {
        if (event && event.target) {
          imageSrc.value = event.target.result as string;
        }
      };
    };

    watchEffect(
      () => {
        if (showEditor.value) {
          getImageSrc(file.value);
          cropper && cropper.replace(imageSrc.value);
        }
      },
      { flush: "post" }
    );

    onMounted(() => {
      cropper = new Cropper(image.value, cropperOptions);
    });

    onUnmounted(() => {
      cropper && cropper.destroy();
    });

    return { image, imageSrc, handleFlipHorizontal, handleRotate, handleFlipVertical, saveEditedImage };
  },
});
